import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant'; //

//
interface CreationRequest {
  coin_id: number;
  nth: string;
  number: string;
}

interface CreateResponse extends Response {
  data: null;
}

//
const creation = (data: CreationRequest): Promise<CreateResponse> => {
  return axios.post(Urls.createUrl, data);
};

//
type UseCreateOptions = {
  config?: MutationConfig<typeof creation>;
};

export const useCreate = ({ config }: UseCreateOptions = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    onSuccess: () => {
      //
    },
    mutationFn: creation,
    ...config,
  });
};
